import React from 'react';
export function Footer() {
  return <footer className="bg-navy py-20 px-4 text-cream-white" data-id="element-214">
      <div className="max-w-6xl mx-auto text-center" data-id="element-215">
        <p className="font-display font-bold text-gold text-[24px] mb-6 uppercase tracking-wide" data-id="element-216">
          💛 MENTE EN SILENCIO™
        </p>

        <p className="text-cream-white/70 font-sans font-light max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-217">
          El método de regulación del sueño por ansiedad N°1 para adultos en
          Argentina.
          <br data-id="element-218" />
          Porque dormir bien no debería ser un lujo. Debería ser tu punto de
          partida.
        </p>

        <div className="h-px bg-gold/30 w-full mb-12" data-id="element-219"></div>

        <div className="flex flex-col md:flex-row justify-center gap-8 text-cream-white/60 font-sans font-light text-sm mb-12" data-id="element-220">
          <a href="mailto:contacto@menteensilencio.com.ar" className="hover:text-gold transition-colors" data-id="element-221">
            contacto@menteensilencio.com.ar
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-222">
            @menteensilencio
          </a>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-223">
            menteensilencio.com.ar
          </a>
        </div>

        <p className="text-cream-white/40 font-sans font-light text-xs mb-8" data-id="element-224">
          © Mente en Silencio™ 2026 — Todos los derechos reservados.
        </p>

        <p className="font-display italic text-gold text-[20px]" data-id="element-225">
          Esta noche puede ser diferente. 🌙
        </p>
      </div>
    </footer>;
}